// Implements: F-UIX-018, F-RPT-009
/**
 * The exports "Consumo por ámbito" offers (UIX.5, RPT.8): the reports of the scope on screen, as
 * the server's export twins (`…/export?format=csv|json`, S11b-2) serve them with the same access
 * and the same default range as the reports.
 *
 * An organization offers its consumption, its per-mockup costs and its costs by model and by flow
 * version; a team only the first two (the costs report is the organization's). Plain data.
 */

import type { ExportFormat, ExportReport, ReportTarget } from "../../../types/reports";

export type { ExportFormat, ExportReport };

export const EXPORT_FORMATS: readonly ExportFormat[] = ["csv", "json"];

/** The reports a target may export, in the order the screen offers them. */
export function exportsOf(target: ReportTarget): readonly ExportReport[] {
  return target.kind === "organization" ? ["consumption", "mockups", "costs"] : ["consumption", "mockups"];
}

/** The server's file stem of each report and scope (`export_name`), for an answer naming no file. */
const STEMS: Readonly<Record<ReportTarget["kind"], Readonly<Record<ExportReport, string>>>> = {
  organization: { consumption: "consumo-organizacion", mockups: "mockups-organizacion", costs: "costos-organizacion" },
  team: { consumption: "consumo-equipo", mockups: "mockups-equipo", costs: "costos-organizacion" },
};

export function defaultExportName(target: ReportTarget, report: ExportReport, format: ExportFormat): string {
  return `${STEMS[target.kind][report]}.${format}`;
}
